<template>
	<b-modal
		header-class="header-class-modal-doc-package"
		:title="FormMSG(1, 'Informations')"
		class="modal-success"
		size="lg"
		v-model="open"
		no-close-on-backdrop
		@ok="closeModal"
		ok-variant="success"
		ok-only
	>
		<div>
			<div v-if="isMultiple" class="content-cell-item">
				<div v-for="(item, index) of mapShowDetailDataMultiple" @key="index">
					<row-info-content :item="item" :index="index" />
				</div>
			</div>
			<div v-else>
				<div class="container-mobile animated fadeIn">
					<div class="content-detailsMyTimesheet-mobile">
						<show-detail-planning-cell :showDetailData="mapDataItem" />
					</div>
				</div>
			</div>
		</div>
	</b-modal>
</template>
<script>
import ShowDetailPlanningCell from '@/components/EntryForCrew/Timesheets/TimesheetsEfcTables/ShowDetailPlanningCell';
import RowInfoContent from './RowInfoContent';
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import * as _ from 'lodash';
export default {
	name: 'MoreDetailPlanningCell',
	mixins: [languageMessages, globalMixin],
	components: { RowInfoContent, ShowDetailPlanningCell },
	data: () => ({ isProduction: false }),
	props: {
		showDetailModalCell: {
			type: Boolean,
			default: false,
			required: false
		},
		itemGenerated: {
			type: Array,
			required: false,
			default: () => []
		},
		isMultiple: {
			type: Boolean,
			default: false,
			required: false
		}
	},
	computed: {
		open: {
			get() {
				return this.showDetailModalCell;
			},
			set(val) {
				return val;
			}
		},
		mapShowDetailDataMultiple() {
			const data = this.itemGenerated;
			const response = this.generatedArrayGrouping(data);
			return response;
		},
		mapDataItem() {
			if (this.mapShowDetailDataMultiple.length === 1) {
				return this.mapShowDetailDataMultiple[0].data[0];
			}
		}
	},
	data: () => ({ isCollapsed: false }),
	methods: {
		generatedArrayGrouping(data) {
			const filterItem = data.map((item) => ({
				date: item.date,
				userId: item.userId,
				fullName: item.fullName,
				functionName: item.functionName,
				tsDay: item.tsDay
			}));
			const response = filterItem.reduce((accumulator, current) => {
				let existingItem = accumulator.find(
					(item) => item.userId === current.userId && item.fullName === current.fullName && item.functionName === current.functionName
				);
				if (existingItem) {
					existingItem.data.push(current.tsDay);
				} else {
					accumulator.push({
						data: [current.tsDay],
						userId: current.userId,
						fullName: current.fullName,
						functionName: current.functionName,
						date: current.date
					});
				}
				return accumulator;
			}, []);
			return response;
		},
		closeModal() {
			this.$emit('hideModal');
		},
		handleShowContent() {
			this.isCollapsed = !this.isCollapsed;
		},
		getNumber(total) {
			if (!_.isNil(total)) {
				return total.length.toString().padStart(2, '0');
			}
			return '00';
		},
		shortedByDate(data) {
			const shortEd = data.sort((a, b) => new Date(a.date) - new Date(b.date));
			return shortEd;
		}
	}
};
</script>
<style lang="scss">
.content-cell-item {
	gap: 10px;
	display: flex;
	justify-content: center;
	flex-direction: column;
}
</style>
